/**
 * Add complete-the-set companions immediately from the current page.
 */
(function () {
  if (window.RarelyCompleteTheSet) return;

  function refreshCart() {
    var drawer = document.querySelector('cart-drawer-component');
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var badge = document.getElementById('cart-badge');
        if (badge) badge.textContent = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'rarely-complete-the-set' }
        }));
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (window.__refreshCartUI) return window.__refreshCartUI();
        return cart;
      });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function fromRarelyYoung() {
    try {
      return new URLSearchParams(window.location.search).get('from') === 'rarely-young';
    } catch (e) {
      return false;
    }
  }

  function applyKit() {
    if (!fromRarelyYoung()) return;
    var young = document.querySelectorAll('[data-rarely-complete-set][data-kit="rarely-young"]');
    if (!young.length) return;
    document.querySelectorAll('[data-rarely-complete-set][data-kit="adult"]').forEach(function (el) {
      el.hidden = true;
    });
    young.forEach(function (el) {
      el.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyKit);
  } else {
    applyKit();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList.contains('rarely-cts__form')) return;
    event.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var button = form.querySelector('button');
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding';
    }
    addItems([{ id: String(id.value), quantity: 1 }])
      .then(refreshCart)
      .catch(function (error) { console.error('[Rarely complete the set]', error); })
      .finally(function () {
        if (!button) return;
        button.disabled = false;
        button.textContent = 'Add';
      });
  });

  window.RarelyCompleteTheSet = true;
})();
